import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';
declare var $: any;

@Component({
  selector: 'app-attributes-list',
  templateUrl: './attributes-list.component.html',
  styleUrls: ['./attributes-list.component.scss'],
})
export class AttributesListComponent extends BaseListCtl {
  public applicationId: number = 0;
  public apiUsecaseId: number = 0;

  types: { value: string; label: string }[] = [
    { value: '', label: '--Type--' },
    { value: 'text', label: 'text' },
    { value: 'number', label: 'number' },
    { value: 'long', label: 'long' },
    { value: 'decimal', label: 'decimal' },
    { value: 'date', label: 'date' },
    { value: 'time', label: 'time' },
    { value: 'email', label: 'email' },
    { value: 'url', label: 'url' },
    { value: 'object', label: 'object' },
    { value: 'list', label: 'list' },
    { value: 'map', label: 'map' },
    { value: 'doc', label: 'doc' },
    { value: 'file', label: 'image' },
    { value: 'expression', label: 'expression' },
  ];

  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute
  ) {
    super('', locator, route);
    let _self = this;
    locator.getPathVariable(route, function (params: any) {
      //+ operator is mentions to convert number into string
      _self.applicationId = +params.get('appId');
      _self.apiUsecaseId = +params.get('usecaseId');
      _self.form.data['appId'] = _self.applicationId;
      _self.form.searchParams['appId'] = _self.applicationId;
      _self.getUsecase(_self.apiUsecaseId);
    });

    locator.config
      .getProperty('endpoint.userstory')
      .then((property: string) => {
        this.initApiEndpoint(property);
      });
  }

  override populateForm(form: any, data: any) {
    form.id = data.id;
    form.name = data.name;
    form.title = data.title;
    form.code = data.code;
    form.description = data.description;
    form.appId = data.appId;
    form.archiveEnabled = data.archiveEnabled;
    form.attachmentEnabled = data.attachmentEnabled;
    form.changeLog = data.changeLog;
    form.commentEnabled = data.commentEnabled;
    form.emailEnabled = data.emailEnabled;
    form.exportEnabled = data.exportEnabled;
    form.versionHistory = data.versionHistory;
    form.groupFilter = data.groupFilter;
    form.excelAttributes = data.excelAttributes;
    form.dropdown = data.dropdown;
    form.dropdownList = data.dropdownList;
  }

  /**
   * Filer list by usecase name
   */
  public searchUsecaseItem: string = '';

  /**
   *
   * @returns Filter useacases
   */
  public filterUsecases(): any {
    let searchTerm = this.searchUsecaseItem.toLowerCase();
    return this.form.list.filter((e: any) =>
      (e['name'] + '').toLowerCase().includes(searchTerm)
    );
  }

  /**
   * Toggle enable attributes
   * @param val
   * @param obj
   * @param name
   */
  public toggleVal(val: any, obj: any, name: string) {
    obj[name] = val ? 1 : 0;
  }

  override preload(): void {}
  /**
   * Get usecase and its attributes
   * @param id
   */
  public getUsecase(id: number) {
    let _self = this;
    _self.get(id, () => {
      if (id > 0) {
        _self.getAttributeListById(id);
      } else {
        _self.form.data['appId'] = _self.applicationId;
      }
    });
  }

  //Usecase attributes
  public attributeList = [];

  /**
   * Get usecase attribute
   * @param usercaseId
   */
  public getAttributeListById(usercaseId: number) {
    let _self = this;
    let url =
      this.locator.getEndpoint('endpoint.userstory.attributes') + '/search';
    let filer = { userstoryId: usercaseId };
    _self.locator.http.post(url, filer, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.attributeList = res.result['data'];
    });
  }

  /**
   * Filer attribute list by label of type
   */
  public searchAttributeItem: string = '';

  public attribFilter: string = '';

  public setAttribFilter(name: string) {
    this.attribFilter = name;
  }

  public filterAttributesByLabelType(): any {
    let _self = this;

    let searchTerm = this.searchAttributeItem.toLowerCase();
    if (_self.attribFilter.length > 0) {
      _self.initializeDataTable();
      return this.attributeList
        .filter((e) => e[_self.attribFilter] == '1')
        .filter((e) =>
          (e['label'] + e['type'] + '').toLowerCase().includes(searchTerm)
        );
    } else {
      return this.attributeList.filter((e) =>
        (e['label'] + e['type'] + '').toLowerCase().includes(searchTerm)
      );
    }
  }

  /**
   * Filter attribute list
   *
   * @returns
   */
  public filterAttributes(): any {
    return this.attributeList.filter(
      (e) =>
        e['type'] === 'text' ||
        e['type'] === 'date' ||
        e['type'] === 'number' ||
        e['type'] === 'object' ||
        e['type'] === 'email' ||
        e['type'] === 'time' ||
        e['type'] === 'url' ||
        e['type'] === 'map'
    );
  }

  /**
   * Contains attribute data
   */
  public atribForm: any = {
    error: false, //error
    message: null, //error or success message
    preload: null, // preload data
    inputerror: {}, // form input error messages
    data: {},
  };

  /**
   * Get an attribute
   *
   * @param id
   * @returns
   */
  public getAttribute(id: number) {
    let _self = this;

    //reset form
    if (id == 0) {
      _self.atribForm['error'] = '';
      _self.atribForm['message'] = '';
      _self.atribForm['inputerror'] = {};
      _self.atribForm['data'] = {};
      return;
    }

    let url =
      this.locator.getEndpoint('endpoint.userstory.attributes') + '/get/' + id;

    _self.locator.http.get(url, (res: any, error: boolean) => {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.atribForm['error'] = !res.success;
      _self.atribForm['message'] = res.message;
      if (res.success) {
        _self.atribForm['data'] = res.result['data'];
      }
    });
  }

  /**
   * Delete a usecase attribute
   *
   * @param id Delete an attribute
   * @returns
   */

  /**
   * Delete an attribute
   * @param id
   * @returns
   */
  public deleteAttribute(id: number) {
    let _self = this;
    if (id > 0) {
      let flag = confirm('Are you sure');
      if (flag == false) {
        _self.atribForm['message'] = 'Delet request is canceled';
        return;
      }
    }

    let url =
      this.locator.getEndpoint('endpoint.userstory.attributes') +
      '/delete/' +
      id;

    _self.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      if (res.success) {
        alert('Success: ' + res.message);
        _self.getAttributeListById(_self.applicationId);
      } else {
        alert('Error: ' + res.message);
      }
    });
  }

  /**
   * Save an attribute
   * @param id
   * @returns
   */
  public saveAttribute() {
    let _self = this;

    _self.atribForm['data']['userstoryId'] = _self.applicationId;

    let url =
      this.locator.getEndpoint('endpoint.userstory.attributes') + '/save';

    _self.locator.http.post(
      url,
      _self.atribForm['data'],
      (res: any, error: boolean) => {
        if (error) {
          alert('Server Error:' + error);
          return;
        }
        _self.atribForm['error'] = !res.success;
        _self.atribForm['message'] = res.message;
        _self.atribForm['inputerror'] = res.result['inputerror'];

        if (res.success) {
          _self.getAttributeListById(_self.applicationId);
        }
      }
    );
  }

  //Value of an attribute
  public tempAttributeValue = '';

  //Add new value to an attribute
  public addAttributeValue() {
    let val = this.tempAttributeValue.trim();
    if (val.length == 0) {
      alert('Enter a value');
      return;
    }
    let values = this.atribForm['data']['values'];
    if (!this.atribForm['data']['values']) {
      this.atribForm['data']['values'] = [];
    }
    const index = this.atribForm['data']['values'].indexOf(val);
    if (index == -1) {
      this.atribForm['data']['values'].push(val);
    }
    this.tempAttributeValue = '';
    //alert(this.atribForm['data']['values']);
  }

  //Delete new value to an attribute
  public removeAttribueValue(val: string) {
    let _self = this;
    const index = _self.atribForm['data']['values'].indexOf(val);
    if (index !== -1) {
      let flag = confirm('Are you sure');
      if (flag) _self.atribForm['data']['values'].splice(index, 1);
    }
  }

  /**
   * Add or remove an element from the list
   * @param list
   * @param val
   * @param rem
   */
  public updateList(listName: string, val: string, rem: boolean) {
    let _self = this;

    if (!_self.locator.dataValidator.isNotNull(val)) {
      return;
    }

    //console.log('Update list', listName, _self.form.data);

    if (!_self.form.data[listName]) {
      _self.form.data[listName] = [];
      _self.form.data[listName].push(val);
      console.log('Updatd list', _self.form.data[listName]);
      return;
    }

    const index = _self.form.data[listName].indexOf(val);

    if (rem) {
      // If the item is found, remove it using Array.splice
      if (index !== -1) {
        let flag = confirm('Are you sure');
        if (flag) _self.form.data[listName].splice(index, 1);
      }
    } else {
      if (index == -1) {
        _self.form.data[listName].push(val);
      }
    }
  }

  //------------Type Map------------

  public tempMapValue = '';
  public tempKey = '';

  /**
   * Add new key-value pair to the Map
   * @returns
   */
  public addAttributeMapValue(): void {
    const key = this.tempKey.trim();
    const value = this.tempMapValue.trim();

    if (key.length === 0 || value.length === 0) {
      alert('Enter both key and value');
      return;
    }

    // Ensure map array is initialized
    if (!Array.isArray(this.atribForm.data.values)) {
      this.atribForm.data.values = [];
    }

    // Check if key already exists
    const index = this.atribForm.data.values.findIndex(
      (item: { key: string; value: string }) => item.key === key
    );
    if (index === -1) {
      this.atribForm.data.values.push({ key, value });
    } else {
      alert('Key already exists');
    }
    // Clear the input fields
    this.tempKey = '';
    this.tempMapValue = '';
  }

  /**
   * Remove key-value pair from the Map
   * @param key
   * @returns
   */
  public removeAttribueMapValue(key: string): void {
    if (!Array.isArray(this.atribForm.data.values)) {
      return;
    }
    const index = this.atribForm.data.values.findIndex(
      (item: { key: string; value: string }) => item.key === key
    );
    if (index !== -1) {
      const flag = confirm('Are you sure');
      if (flag) {
        this.atribForm.data.values.splice(index, 1);
      }
    }
  }

  /**
   * Move attribute index
   */
  moveIndex(id: number, position: number) {
    let _self = this;

    let url =
      this.locator.getEndpoint('endpoint.userstory.attributes') +
      '/move/' +
      id +
      '/' +
      position;

    _self.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      if (res.success) {
        //alert("Success: " + res.message);
        _self.attributeList = res.result.data;
      }
    });
  }

  /**
   * Initialize DataTable
   */

  override async initializeDataTable(): Promise<void> {
    try {
      const tableElement = $('#dataTableId');
      if ($.fn.dataTable.isDataTable(tableElement)) {
        tableElement.DataTable().clear().destroy();
      }
      await this.waitForDocumentReady();
      if ($.fn.dataTable) {
        const table = $('#dataTableId').DataTable({
          lengthChange: false,
          paging: false, // Disable pagination
          info: false, // Disable the "Showing X to Y of Z entries" info
          dom: '<"row align-items-center"<"col-3"f><"col-1 custom-button-container"> <"col-4 custom-add-container"><"col-4 text-right"B>>rt', // Configure the layout
          buttons: [
            {
              extend: 'copy',
            },
            {
              extend: 'excelHtml5',
            },
            {
              extend: 'pdfHtml5',
            },
            {
              extend: 'print',
            },
          ],
        });

        // Insert custom button HTML into the placeholder container
        $('.custom-button-container').html(`
            <a
              class="btn btn-outline-secondary btn-sm radius-30 "
              data-bs-toggle="modal"
              data-bs-target="#scrollableModal"
            
              title="Filter"
            >
              <i class="lni lni-funnel"></i> 
            </a>
          `);
        $('.custom-add-container').html(`
          <a
            class="btn btn-outline-secondary btn-sm radius-30 "
            data-bs-toggle="modal"
            data-bs-target="#editModal"        
            title="Add"
          >
          <i style="font-family: 'Times New Roman', Times, serif;" class="bx bx-plus me-0"></i>Add
           
          </a>
        `);
        // Manually bind the click event using jQuery
        $('.custom-add-container a').on('click', () => {
          this.get(0);
          this.resetForm();
        });

        // Append buttons container to the third col-4 element
        table
          .buttons()
          .container()
          .appendTo('#dataTableId_wrapper .col-4:eq(2)');
      } else {
        console.error(
          'DataTable is not defined. Please check if the DataTable library is correctly loaded.'
        );
      }
    } catch (error) {
      console.error('Error initializing DataTable:', error);
    }
  }

  goto() {
    this.forward('api/' + this.apiUsecaseId);
  }
  gotoData() {
    this.forward('usecasedata/' + this.applicationId);
  }
}
